export default __webpack_public_path__ + "static/media/leftInActive.db2ba4f8.svg";